// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  projectSummaryModalClose,
  updateModalPathSet,
} from 'redux/modules/projectSummary'

const removePathFromModalPathSet = pathId => (dispatch, getState) => {
  const { projectSummary } = getState()

  // get their indexes in the immutable List
  const highlightedIndex = projectSummary.get('highlightedPaths').indexOf(pathId)
  const modalPathIndex = projectSummary.get('modalPathsSet').indexOf(pathId)

  // if the specified path id was not in one of these lists,
  // something in redux is out of sync. this should never display in production
  if (!~highlightedIndex) {
    console.warn(`Warning: removePathFromModalPathSet pathId ${pathId} was not found in highlightedPaths`)
  }
  if (!~modalPathIndex) {
    console.warn(`Warning: removePathFromModalPathSet pathId ${pathId} was not found in modalPathsSet`)
  }

  // these are the new lists sans given pathId
  const highlightedPaths = projectSummary.get('highlightedPaths').delete(highlightedIndex)
  const modalPathsSet = projectSummary.get('modalPathsSet').delete(modalPathIndex)

  // if we are gonna remove the last path from the modal,
  // then there's no point in having the modal open
  if (!modalPathsSet.size) {
    dispatch(projectSummaryModalClose())
  }

  dispatch(updateModalPathSet(highlightedPaths, modalPathsSet))
}

export default removePathFromModalPathSet
